/** Keep existing Nordic rules; Dutch input accepts national and international notation. */
export function validatePhoneNumber(value, locale) {
    const language = String(locale).toLowerCase().replace('-', '_');
    const input = String(value);
    if (['nb_no', 'da_dk'].includes(language)) {
        return /^[2-9]\d{7}$/.test(input);
    }
    if (language === 'sv_se') {
        return /^0\d{6,9}$/.test(input);
    }
    if (language !== 'nl_nl') {
        return false;
    }

    let phone = input.trim().replace(/[\s().-]+/gu, '');
    if (phone.startsWith('00')) {
        phone = `+${phone.slice(2)}`;
    }
    if (!phone.startsWith('+')) {
        if (phone.startsWith('0')) {
            phone = phone.slice(1);
        } else if (phone.length === 11 && phone.startsWith('31')) {
            phone = phone.slice(2);
        }
        phone = `+31${phone}`;
    }
    if (phone.startsWith('+310')) {
        phone = `+31${phone.slice(4)}`;
    }
    if (!/^\+[1-9]\d{6,14}$/.test(phone)) {
        return false;
    }
    return !phone.startsWith('+31') || /^\+31[1-9]\d{8}$/.test(phone);
}

export function filterPostalCode(value, locale) {
    const language = String(locale).toLowerCase().replace('-', '_');
    const input = String(value);
    return language === 'nl_nl'
        ? input.toUpperCase().replace(/[^0-9A-Z\s]/g, '')
        : input.replace(/[^0-9\s]/g, '');
}
